<template>
  <div class="view">
    <h2 class="ui header inverted">Join</h2>
    <div>
      <sui-message icon="circle notch loading" header="Loading" info v-if="loading">
        You will be joined the team in a few seconds...
      </sui-message>
      <sui-message icon="times circle" header="Fail" negative v-if="!loading && error">
        {{error}}
      </sui-message>
      <sui-message icon="check circle" header="Success" positive v-if="!loading && !error">
        You will be redirected to the
        <router-link to="/user/login" v-show="!token">Log in</router-link>
        <router-link to="/user/login" v-show="token">Dashboard</router-link>
        page in <code>{{seconds}}</code> {{pluralize('second', seconds)}}.
      </sui-message>
    </div>
  </div>
</template>

<script>
  import {mapState} from 'vuex'
  import api from '@/api'

  export default {
    name: 'AccountJoin',
    data() {
      return {
        seconds: 6,
        loading: false,
        error: null,
      }
    },
    computed: {
      ...mapState(['token']),
    },
    methods: {
      updateTimer() {
        this.seconds -= 1
        if (this.seconds < 0) {
          this.$router.push('/user/login')
        }
      },
      startTimer() {
        this.$options.interval = setInterval(this.updateTimer, 1000)
      },
      stopTimer() {
        clearInterval(this.$options.interval)
      },
    },
    mounted() {
      this.loading = true
      this.error = null
      api.accept(this.$route.query.email, this.$route.query.invitationId).then(data => {
        if (data.success) {
          this.startTimer()
        } else {
          this.error = data.error
        }
      }).catch(error => {
        this.error = error.message
      }).finally(() => {
        this.loading = false
      })
    },
    beforeDestroy() {
      this.stopTimer()
    },
  }
</script>

<style scoped>
  .view { display: flex; flex-direction: column; align-items: center; }
</style>
